import * as amplitude from "@amplitude/analytics-browser";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  if (config.public.AMPLITUDE_API_KEY === "disabled") {
    return {};
  }

  amplitude.init(config.public.AMPLITUDE_API_KEY as string, {
    serverUrl: config.public.AMPLITUDE_SERVER_URL as string,
  });

  return {
    provide: {
      amplitude,
    },
  };
});
